<div class="lists-wrapper">
  <div class="background-wrapper">
    <h1 class="title color-black mb-5">Inizia la tua avventura</h1>
    <div class="container form-wrapper">
      <app-auth-tab-buttons></app-auth-tab-buttons>

      <mat-slide-toggle [(ngModel)]="isCompany" [labelPosition]="'before'" color="primary" id="isCompanyCheckbox">
        <span class="form-label color-white">Vuoi registrarti come Entità Giuridica per richiedere fattura?</span>
      </mat-slide-toggle>

      <hr class="mb-5">

      @if (!isCompany) {
        <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
          <div class="form-part-one row">
            <div class="col-12 col-md-6 mb-5">
              <label class="form-label" for="email">Indirizzo Email*</label>
              <input
                [class.is-invalid]="isInvalid(registerForm, 'email')"
                class="form-control register-input form-control-lg rounded-0"
                formControlName="email"
                id="email"
                type="email"
                />
              @if (isInvalid(registerForm, 'email')) {
                <small class="form-text text-danger">
                  @if (getError(registerForm, 'email')?.required) {
                    <span>
                      Email è obbligatorio
                    </span>
                  }
                  @if (getError(registerForm, 'email')?.email) {
                    <span>
                      L'email non è valida
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(registerForm, 'email')) {
                    <span>
                      {{ serverSideError(registerForm, "email") }}
                    </span>
                  }
                </small>
              }
            </div>
            <div class="col-12 col-md-6 mb-5">
              <label class="form-label" for="phone_number">Numero di telefono*</label>
              <input
                [class.is-invalid]="isInvalid(registerForm, 'phone_number')"
                class="form-control register-input form-control-lg rounded-0"
                formControlName="phone_number"
                id="phone_number"
                type="text"
                />
              @if (isInvalid(registerForm, 'phone_number')) {
                <small
                  class="form-text text-danger"
                  >
                  @if (getError(registerForm, 'phone_number')?.required) {
                    <span>
                      Numero di telefono è obbligatorio
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(registerForm, 'phone_number')) {
                    <span>
                      {{ serverSideError(registerForm, "phone_number") }}
                    </span>
                  }
                </small>
              }
            </div>
            <div class="col-12 col-md-6 mb-5">
              <label class="form-label" for="first_name">Nome*</label>
              <input
                [class.is-invalid]="isInvalid(registerForm, 'first_name')"
                class="form-control register-input form-control-lg rounded-0"
                formControlName="first_name"
                id="first_name"
                type="text"
                />
              @if (isInvalid(registerForm, 'first_name')) {
                <small class="form-text text-danger">
                  @if (getError(registerForm, 'first_name')?.required) {
                    <span>
                      Nome è obbligatorio
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(registerForm, 'first_name')) {
                    <span>
                      {{ serverSideError(registerForm, "first_name") }}
                    </span>
                  }
                </small>
              }
            </div>
            <div class="col-12 col-md-6 mb-5">
              <label class="form-label" for="last_name">Cognome*</label>
              <input
                [class.is-invalid]="isInvalid(registerForm, 'last_name')"
                class="form-control register-input form-control-lg rounded-0"
                formControlName="last_name"
                id="last_name"
                type="text"
                />
              @if (isInvalid(registerForm, 'last_name')) {
                <small class="form-text text-danger">
                  @if (getError(registerForm, 'last_name')?.required) {
                    <span>
                      Cognome è obbligatorio
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(registerForm, 'last_name')) {
                    <span>
                      {{ serverSideError(registerForm, "last_name") }}
                    </span>
                  }
                </small>
              }
            </div>
            <div class="col-12 col-md-6 mb-5">
              <label class="form-label" for="fromInputFrom">Data di nascita*</label>
              <div class="input-group">
                <input
                  (click)="fromPicker.open()"
                  [matDatepicker]="$any(fromPicker)"
                  [readonly]="true"
                  class="form-control bg-white register-input form-control-lg rounded-0 cp"
                  formControlName="birthdate"
                  id="fromInputFrom"
                  name="birthdate"
                  placeholder="gg/mm/aaaa"
                  />
                <span class="input-group-text py-0 px-1">
                  <mat-datepicker-toggle [for]="fromPicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #fromPicker [startAt]="startDate" startView="multi-year"></mat-datepicker>
              </div>
              @if (isInvalid(registerForm, 'birthdate')) {
                <small class="form-text text-danger">
                  @if (getError(registerForm, 'birthdate')?.required) {
                    <span>
                      Data di nascita è obbligatorio
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(registerForm, 'birthdate')) {
                    <span>
                      {{ serverSideError(registerForm, "birthdate") }}
                    </span>
                  }
                </small>
              }
            </div>
            <!--            <div class="col-12 col-md-6 mb-5">-->
            <!--              <label for="location" class="form-label">Località*</label>-->
            <!--              <input-->
            <!--                formControlName="location"-->
            <!--                type="text"-->
            <!--                class="form-control register-input form-control-lg rounded-0"-->
            <!--                id="location"-->
            <!--                [class.is-invalid]="isInvalid(registerForm, 'location')"-->
            <!--              />-->
            <!--              <small-->
            <!--                *ngIf="isInvalid(registerForm, 'location')"-->
            <!--                class="form-text text-danger"-->
            <!--              >-->
            <!--                <span *ngIf="getError(registerForm, 'location')?.required">-->
            <!--                  Località è obbligatorio-->
          <!--                </span>-->
          <!--                &lt;!&ndash; server-side validation errors &ndash;&gt;-->
          <!--                <span *ngIf="serverSideError(registerForm, 'location')">-->
          <!--                  {{ serverSideError(registerForm, "location") }}-->
        <!--                </span>-->
      <!--              </small>-->
    <!--            </div>-->
    <div class="w-100"></div>
    <div class="col-12 col-md-6 mb-5 disabled-bg ">
      <label class="form-label" for="fiscal_code">Codice Fiscale*</label>
      <input
        [class.is-invalid]="isInvalid(registerForm, 'fiscal_code')"
        class="form-control register-input form-control-lg rounded-0"
        formControlName="fiscal_code"
        id="fiscal_code"
        type="text"
        />
      @if (isInvalid(registerForm, 'fiscal_code')) {
        <small
          class="form-text text-danger"
          >
          @if (getError(registerForm, 'fiscal_code')?.required) {
            <span>
              Codice Fiscale è obbligatorio
            </span>
          }
          @if (getError(registerForm, 'fiscal_code')?.maxlength) {
            <span>
              Il campo  Codice Fiscale potrebbe non essere maggiore di {{
              getError(registerForm, 'fiscal_code')?.maxlength?.requiredLength
              }} caratteri.
            </span>
          }
          @if (getError(registerForm, 'fiscal_code')?.minlength) {
            <span>
              Il campo Codice Fiscale deve essere almeno {{
              getError(registerForm, 'fiscal_code')?.minlength?.requiredLength
              }} caratteri.
            </span>
          }
          <!-- server-side validation errors -->
          @if (serverSideError(registerForm, 'fiscal_code')) {
            <span>
              {{ serverSideError(registerForm, "fiscal_code") }}
            </span>
          }
        </small>
      }
    </div>
    <div class="col-12 col-md-6 mb-5">
      <label class="form-label">Nazione*</label>
      <ng-autocomplete
        (inputChanged)="nationSearchQuery$.next($event)"
        (inputCleared)="clearNationsValue(registerForm, 'nation')"
        (selected)="setNationsValue(registerForm, 'nation', $event)"
        [data]="nations"
        [debounceTime]="100"
        [focusFirst]="true"
        [itemTemplate]="itemTemplate"
        [notFoundTemplate]="notFoundTemplate"
        [searchKeyword]="keyword"
        notFoundText="Nessuna Nazione trovata"
        placeholder="Seleziona Nazione"
      ></ng-autocomplete>
      <small class="form-text text-white">*Nazione deve essere ISO country code max 3 characters.</small>
      @if (isInvalid(registerForm, 'nation')) {
        <small class="form-text text-danger">
          <br>
            @if (getError(registerForm, 'nation')?.required) {
              <span>
                Nazione è obbligatorio
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'nation')) {
              <span>
                {{ serverSideError(registerForm, "nation") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5 disabled-bg">
        <label class="form-label">Provincia*</label>
        <ng-autocomplete
          #autocompleteRef
          (inputChanged)="provinceSearchQuery$.next($event)"
          (inputCleared)="clearValue(registerForm, 'province')"
          (selected)="setValue(registerForm, 'province', $event)"
          [data]="provinces"
          [debounceTime]="100"
          [disabled]="isAutoCompleteDisabled"
          [focusFirst]="true"
          [initialValue]="initialValue"
          [itemTemplate]="itemTemplate"
          [notFoundTemplate]="notFoundTemplate"
          [searchKeyword]="keyword"
          notFoundText="Nessuna provincia trovata"
          placeholder="Seleziona provincia"
        ></ng-autocomplete>
        @if (isInvalid(registerForm, 'province')) {
          <small class="form-text text-danger">
            @if (getError(registerForm, 'province')?.required) {
              <span>
                Provincia è obbligatorio
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'province')) {
              <span>
                {{ serverSideError(registerForm, "province") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="zip">CAP*</label>
        <input
          [class.is-invalid]="isInvalid(registerForm, 'zip')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="zip"
          id="zip"
          type="text"
          />
        @if (isInvalid(registerForm, 'zip')) {
          <small class="form-text text-danger">
            @if (getError(registerForm, 'zip')?.required) {
              <span>
                CAP è obbligatorio
              </span>
            }
            @if (getError(registerForm, 'zip')?.maxlength) {
              <span>
                Il campo CAP potrebbe non essere maggiore di {{
                getError(registerForm, 'zip')?.maxlength?.requiredLength
                }} caratteri.
              </span>
            }
            @if (getError(registerForm, 'zip')?.minlength) {
              <span>
                Il campo CAP deve essere almeno {{
                getError(registerForm, 'zip')?.minlength?.requiredLength
                }} caratteri.
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'zip')) {
              <span>
                {{ serverSideError(registerForm, "zip") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="city">Citta*</label>
        <input
          [class.is-invalid]="isInvalid(registerForm, 'city')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="city"
          id="city"
          type="text"
          />
        @if (isInvalid(registerForm, 'city')) {
          <small
            class="form-text text-danger"
            >
            @if (getError(registerForm, 'city')?.required) {
              <span>
                Citta è obbligatorio
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'city')) {
              <span>
                {{ serverSideError(registerForm, "city") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="street">Indirizzo*</label>
        <input
          [class.is-invalid]="isInvalid(registerForm, 'street')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="street"
          id="street"
          type="text"
          />
        @if (isInvalid(registerForm, 'street')) {
          <small
            class="form-text text-danger"
            >
            @if (getError(registerForm, 'street')?.required) {
              <span>
                Indirizzo è obbligatorio
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'street')) {
              <span>
                {{ serverSideError(registerForm, "street") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="w-100"></div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="password">Password*</label>
        <input
          [class.is-invalid]="isInvalid(registerForm, 'password')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="password"
          id="password"
          type="password"
          />
        @if (isInvalid(registerForm, 'password')) {
          <small
            class="form-text text-danger"
            >
            @if (getError(registerForm, 'password')?.required) {
              <span>
                Password è obbligatorio
              </span>
            }
            @if (getError(registerForm, 'password')?.minlength) {
              <span>
                la lunghezza minima richiesta è
                {{ getError(registerForm, "password")?.minlength?.requiredLength }}
              </span>
            }
            @if (getError(registerForm, 'password')?.pattern) {
              <span class="d-block">
                Password deve contenere 1 numero, 1 lettera maiuscola e almeno 1 carattere speciale.
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'password')) {
              <span>
                {{ serverSideError(registerForm, "password") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="password_confirmation">Conferma Password*</label>
        <input
                [class.is-invalid]="
                  isInvalid(registerForm, 'password_confirmation')
                "
          class="form-control register-input form-control-lg rounded-0"
          formControlName="password_confirmation"
          id="password_confirmation"
          type="password"
          />
        @if (isInvalid(registerForm, 'password_confirmation')) {
          <small
            class="form-text text-danger"
            >
            @if (
              getError(registerForm, 'password_confirmation')?.required
              ) {
              <span
                >
                Password è obbligatorio
              </span>
            }
            @if (
              getError(registerForm, 'password_confirmation')?.minlength
              ) {
              <span
                >
                la lunghezza minima richiesta è
                {{
                getError(registerForm, "password_confirmation")?.minlength
                ?.requiredLength
                }}
              </span>
            }
            @if (
              getError(registerForm, 'password_confirmation')?.mustMatch
              ) {
              <span
                >
                passwords non corrispondono
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'password_confirmation')) {
              <span
                >
                {{ serverSideError(registerForm, "password_confirmation") }}
              </span>
            }
          </small>
        }
      </div>
    </div>
    <div class="row">
      <span class="form-text text-white">*campi obbligatori</span>
    </div>
    @if (settings(); as settings) {
      <div class="row mt-5">
        <p class="register-text col-12 mb-3">
          Il/la sottoscritto/a, in qualità di Interessato, presa visione dell'<a
          (click)="openPrivacyPolicyOnNewTab()"
        class="btn btn-link btn-link-primary rounded-0 py-0 px-1 external-link">informativa clienti</a> e
        Acconsente:
      </p>
      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="general_contact">
          Alle Condizioni Generali di Contratto per l'utilizzo del
        </mat-checkbox>
        <a (click)="openConditionsModal()"
        class="btn btn-link btn-link-primary rounded-0 py-0 px-1 external-link">Sito</a>*
        @if (isInvalid(registerForm, 'general_contact')) {
          <small class="form-text text-danger">
            @if ( getError(registerForm, 'general_contact')?.required) {
              <span>
                Le Condizioni Generali di Contratto per l'utilizzo del Sito sono obbligatorie
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(registerForm, 'general_contact')) {
              <span>
                {{ serverSideError(registerForm, "general_contact") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="profile_privacy">
          Al trattamento dei dati per finalità di invio di aggiornamenti
          periodici sulle attività di {{ settings.agency_name }} e di comunicazioni
          promozionali circa sconti, offerte, servizi o eventi di
          {{ settings.agency_name }};
        </mat-checkbox>
      </div>
      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="thirdparty_privacy">
          Al trattamento dei dati per finalità di profilazione, quali ad
          esempio l’analisi delle preferenze operate con mezzi automatizzati
          per il miglioramento dell’offerta commerciale, oppure attraverso
          l’invio di sondaggi o questionari di rilevazione della
          soddisfazione dei clienti in relazione ai servizi di
          {{ settings.agency_name }};
        </mat-checkbox>
      </div>
      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="marketing_privacy">
          Alla comunicazione dei dati a società partner di
          {{ settings.agency_name }} per l'invio di comunicazioni commerciali e promozionali da parte di tali
          società terze;
        </mat-checkbox>
      </div>
      <div class="col-md-12 mt-5 d-flex justify-content-center">
        <button
          [disabled]="isLoading()"
          class=" btn btn-main-bg px-2 color-white py-4 btn-form"
          mat-button
          type="submit"
          >
          @if (isLoading()) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
            } Registrati
          </button>
        </div>
      </div>
    }
  </form>
} @else {
  <form (ngSubmit)="registerCompany()" [formGroup]="companyForm">
    <div class="form-part-one row">
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="emailCompany">Indirizzo Email*</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'email')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="email"
          id="emailCompany"
          type="email"
          />
        @if (isInvalid(companyForm, 'email')) {
          <small
            class="form-text text-danger"
            >
            @if (getError(companyForm, 'email')?.required) {
              <span>
                Email è obbligatorio
              </span>
            }
            @if (getError(companyForm, 'email')?.email) {
              <span>
                L'email non è valida
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'email')) {
              <span>
                {{ serverSideError(companyForm, 'email') }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="phone_numberCompany">Numero di telefono*</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'phone_number')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="phone_number"
          id="phone_numberCompany"
          type="text"
          />
        @if (isInvalid(companyForm, 'phone_number')) {
          <small class="form-text text-danger">
            @if (getError(companyForm, 'phone_number')?.required) {
              <span>
                Numero di telefono è obbligatorio
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'phone_number')) {
              <span>
                {{ serverSideError(companyForm, "phone_number") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="business_name">Bussiness name*</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'business_name')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="business_name"
          id="business_name"
          type="text"
          />
        @if (isInvalid(companyForm, 'business_name')) {
          <small class="form-text text-danger">
            @if (getError(companyForm, 'business_name')?.required) {
              <span>
                Nome è obbligatorio
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'business_name')) {
              <span>
                {{ serverSideError(companyForm, "business_name") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="vat_number">Partita IVA*</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'vat_number')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="vat_number"
          id="vat_number"
          type="text"
          />
        @if (isInvalid(companyForm, 'vat_number')) {
          <small class="form-text text-danger">
            @if (getError(companyForm, 'vat_number')?.required) {
              <span>
                Partita IVA è obbligatorio
              </span>
            }
            @if (getError(companyForm, 'vat_number')?.maxlength) {
              <span>
                Il campo Partita IVA potrebbe non essere maggiore di {{
                getError(companyForm, 'vat_number')?.maxlength?.requiredLength
                }} caratteri.
              </span>
            }
            @if (getError(companyForm, 'vat_number')?.minlength) {
              <span>
                Il campo Partita IVA deve essere almeno {{
                getError(companyForm, 'vat_number')?.minlength?.requiredLength
                }} caratteri.
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'vat_number')) {
              <span>
                {{ serverSideError(companyForm, "vat_number") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="pec_email_address">PEC Email*</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'pec_email_address')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="pec_email_address"
          id="pec_email_address"
          type="email"
          />
        @if (isInvalid(companyForm, 'pec_email_address')) {
          <small
            class="form-text text-danger"
            >
            @if (getError(companyForm, 'pec_email_address')?.required) {
              <span>
                Email è obbligatorio
              </span>
            }
            @if (getError(companyForm, 'pec_email_address')?.email) {
              <span>
                L'email non è valida
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'pec_email_address')) {
              <span>
                {{ serverSideError(companyForm, "pec_email_address") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label" for="sdi_code">Codice SDI</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'sdi_code')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="sdi_code"
          id="sdi_code"
          type="text"
          />
        @if (isInvalid(companyForm, 'sdi_code')) {
          <small class="form-text text-danger">
            @if (getError(companyForm, 'sdi_code')?.required) {
              <span>
                SCI Code è obbligatorio
              </span>
            }
            @if (getError(companyForm, 'sdi_code')?.maxlength) {
              <span>
                Il campo Codice SDI potrebbe non essere maggiore di {{
                getError(companyForm, 'sdi_code')?.maxlength?.requiredLength
                }} caratteri.
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'sdi_code')) {
              <span>
                {{ serverSideError(companyForm, "sdi_code") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="w-100"></div>
      <div class="col-12 col-md-6 mb-5 disabled-bg">
        <label class="form-label" for="fiscal_codeCompany">Codice Fiscale*</label>
        <input
          [class.is-invalid]="isInvalid(companyForm, 'fiscal_code')"
          class="form-control register-input form-control-lg rounded-0"
          formControlName="fiscal_code"
          id="fiscal_codeCompany"
          type="text"
          />
        @if (isInvalid(companyForm, 'fiscal_code')) {
          <small class="form-text text-danger">
            @if (getError(companyForm, 'fiscal_code')?.required) {
              <span>
                Codice Fiscale è obbligatorio
              </span>
            }
            @if (getError(companyForm, 'fiscal_code')?.maxlength) {
              <span>
                Il campo Codice Fiscale potrebbe non essere maggiore di {{
                getError(companyForm, 'fiscal_code')?.maxlength?.requiredLength
                }} caratteri.
              </span>
            }
            @if (getError(companyForm, 'fiscal_code')?.minlength) {
              <span>
                Il campo Codice Fiscale deve essere almeno {{
                getError(companyForm, 'fiscal_code')?.minlength?.requiredLength
                }} caratteri.
              </span>
            }
            <!-- server-side validation errors -->
            @if (serverSideError(companyForm, 'fiscal_code')) {
              <span>
                {{ serverSideError(companyForm, "fiscal_code") }}
              </span>
            }
          </small>
        }
      </div>
      <div class="col-12 col-md-6 mb-5">
        <label class="form-label">Nazione*</label>
        <ng-autocomplete
          (inputChanged)="nationSearchQuery$.next($event)"
          (inputCleared)="clearNationsValue(companyForm, 'nation')"
          (selected)="setNationsValue(companyForm, 'nation', $event)"
          [data]="nations"
          [debounceTime]="100"
          [focusFirst]="true"
          [itemTemplate]="itemTemplate"
          [notFoundTemplate]="notFoundTemplate"
          [searchKeyword]="keyword"
          notFoundText="Nessuna Nazione trovata"
          placeholder="Seleziona Nazione"
        ></ng-autocomplete>
        <small class="form-text text-white">*Nazione deve essere ISO country code max 3 characters.</small>
        @if (isInvalid(companyForm, 'nation')) {
          <small class="form-text text-danger">
            <br>
              @if (getError(companyForm, 'nation')?.required) {
                <span>
                  Nazione è obbligatorio
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'nation')) {
                <span>
                  {{ serverSideError(companyForm, "nation") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="col-12 col-md-6 mb-5 disabled-bg ">
          <label class="form-label">Provincia*</label>
          <ng-autocomplete
            (inputChanged)="provinceSearchQuery$.next($event)"
            (inputCleared)="clearValue(companyForm, 'province')"
            (selected)="setValue(companyForm, 'province', $event)"
            [data]="provinces"
            [debounceTime]="100"
            [focusFirst]="true"
            [itemTemplate]="itemTemplate"
            [notFoundTemplate]="notFoundTemplate"
            [searchKeyword]="keyword"
            notFoundText="Nessuna provincia trovata"
            placeholder="Seleziona provincia"
          ></ng-autocomplete>
          @if (isInvalid(companyForm, 'province')) {
            <small class="form-text text-danger">
              @if (getError(companyForm, 'province')?.required) {
                <span>
                  Provincia è obbligatorio
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'province')) {
                <span>
                  {{ serverSideError(companyForm, "province") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="col-12 col-md-6 mb-5">
          <label class="form-label" for="zipCompany">CAP*</label>
          <input
            [class.is-invalid]="isInvalid(companyForm, 'zip')"
            class="form-control register-input form-control-lg rounded-0"
            formControlName="zip"
            id="zipCompany"
            type="text"
            />
          @if (isInvalid(companyForm, 'zip')) {
            <small class="form-text text-danger">
              @if (getError(companyForm, 'zip')?.required) {
                <span>
                  CAP è obbligatorio
                </span>
              }
              @if (getError(companyForm, 'zip')?.maxlength) {
                <span>
                  Il campo CAP potrebbe non essere maggiore di {{
                  getError(companyForm, 'zip')?.maxlength?.requiredLength
                  }} caratteri.
                </span>
              }
              @if (getError(companyForm, 'zip')?.minlength) {
                <span>
                  Il campo CAP deve essere almeno {{
                  getError(companyForm, 'zip')?.minlength?.requiredLength
                  }} caratteri.
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'zip')) {
                <span>
                  {{ serverSideError(companyForm, "zip") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="col-12 col-md-6 mb-5">
          <label class="form-label" for="cityCompany">Citta*</label>
          <input
            [class.is-invalid]="isInvalid(companyForm, 'city')"
            class="form-control register-input form-control-lg rounded-0"
            formControlName="city"
            id="cityCompany"
            type="text"
            />
          @if (isInvalid(companyForm, 'city')) {
            <small class="form-text text-danger">
              @if (getError(companyForm, 'city')?.required) {
                <span>
                  Citta è obbligatorio
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'city')) {
                <span>
                  {{ serverSideError(companyForm, "city") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="col-12 col-md-6 mb-5">
          <label class="form-label" for="streetCompany">Indirizzo*</label>
          <input
            [class.is-invalid]="isInvalid(companyForm, 'street')"
            class="form-control register-input form-control-lg rounded-0"
            formControlName="street"
            id="streetCompany"
            type="text"
            />
          @if (isInvalid(companyForm, 'street')) {
            <small class="form-text text-danger">
              @if (getError(companyForm, 'street')?.required) {
                <span>
                  Indirizzo è obbligatorio
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'street')) {
                <span>
                  {{ serverSideError(companyForm, "street") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="w-100"></div>
        <div class="col-12 col-md-6 mb-5">
          <label class="form-label" for="passwordCompany">Password*</label>
          <input
            [class.is-invalid]="isInvalid(companyForm, 'password')"
            class="form-control register-input form-control-lg rounded-0"
            formControlName="password"
            id="passwordCompany"
            type="password"
            />
          @if (isInvalid(companyForm, 'password')) {
            <small class="form-text text-danger">
              @if (getError(companyForm, 'password')?.required) {
                <span>
                  Password è obbligatorio
                </span>
              }
              @if (getError(companyForm, 'password')?.minlength) {
                <span>
                  la lunghezza minima richiesta è {{ getError(companyForm, "password")?.minlength?.requiredLength }}
                </span>
              }
              @if (getError(companyForm, 'password')?.pattern) {
                <span class="d-block">
                  Password deve contenere 1 numero, 1 lettera maiuscola e almeno 1 carattere speciale.
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'password')) {
                <span>
                  {{ serverSideError(companyForm, "password") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="col-12 col-md-6 mb-5">
          <label class="form-label" for="password_confirmationCompany">Conferma Password*</label>
          <input
                [class.is-invalid]="
                  isInvalid(companyForm, 'password_confirmation')
                "
            class="form-control register-input form-control-lg rounded-0"
            formControlName="password_confirmation"
            id="password_confirmationCompany"
            type="password"
            />
          @if (isInvalid(companyForm, 'password_confirmation')) {
            <small class="form-text text-danger">
              @if ( getError(companyForm, 'password_confirmation')?.required) {
                <span>
                  Password è obbligatorio
                </span>
              }
              @if ( getError(companyForm, 'password_confirmation')?.minlength) {
                <span>
                  la lunghezza minima richiesta è {{
                  getError(companyForm, "password_confirmation")?.minlength?.requiredLength
                  }}
                </span>
              }
              @if ( getError(companyForm, 'password_confirmation')?.mustMatch) {
                <span>
                  passwords non corrispondono
                </span>
              }
              <!-- server-side validation errors -->
              @if (serverSideError(companyForm, 'password_confirmation')) {
                <span>
                  {{ serverSideError(companyForm, "password_confirmation") }}
                </span>
              }
            </small>
          }
        </div>
        <div class="w-100"></div>
        <!--            <div class="col-12 mb-5">-->
        <!--              <mat-checkbox formControlName="privacy_consent">Consenso alla privacy*</mat-checkbox>-->
        <!--              <small *ngIf="isInvalid(companyForm, 'privacy_consent')" class="form-text text-danger">-->
        <!--                <br>-->
        <!--                <span *ngIf="getError(companyForm, 'privacy_consent')?.required">-->
        <!--                  Dovresti accettare la nostra privacy-->
      <!--                </span>-->
      <!--                  <span *ngIf="serverSideError(companyForm, 'privacy_consent')">-->
      <!--                  {{ serverSideError(companyForm, 'privacy_consent') }}-->
    <!--                </span>-->
  <!--              </small>-->
<!--            </div>-->
</div>
<div class="row">
  <span class="form-text text-white mb-5">*campi obbligatori</span>
</div>
@if (settings(); as settings) {
  <div class="row mt-5">
    <p class="register-text col-12 mb-3">
      Il/la sottoscritto/a, in qualità di Interessato, presa visione dell'<a
      (click)="openPrivacyPolicyOnNewTab()" class="btn btn-link btn-link-primary rounded-0 py-0 px-1">informativa
    clienti</a> Acconsente:
  </p>
  <div class="col-md-12 mb-3">
    <mat-checkbox formControlName="general_contact">
      Alle Condizioni Generali di Contratto per l'utilizzo del
    </mat-checkbox>
    <a (click)="openConditionsModal()" class="btn btn-link btn-link-primary rounded-0 py-0 px-1">Sito</a>*
    @if (isInvalid(companyForm, 'general_contact')) {
      <small class="form-text text-danger">
        @if ( getError(companyForm, 'general_contact')?.required) {
          <span>
            Le Condizioni Generali di Contratto per l'utilizzo del Sito sono obbligatorie
          </span>
        }
        <!-- server-side validation errors -->
        @if (serverSideError(companyForm, 'general_contact')) {
          <span>
            {{ serverSideError(companyForm, "general_contact") }}
          </span>
        }
      </small>
    }
  </div>
  <div class="col-md-12 mb-3">
    <mat-checkbox formControlName="profile_privacy">
      Al trattamento dei dati per finalità di invio di aggiornamenti
      periodici sulle attività di {{ settings.agency_name }} e di comunicazioni
      promozionali circa sconti, offerte, servizi o eventi di
      {{ settings.agency_name }};
    </mat-checkbox>
  </div>
  <div class="col-md-12 mb-3">
    <mat-checkbox formControlName="thirdparty_privacy">
      Al trattamento dei dati per finalità di profilazione, quali ad
      esempio l’analisi delle preferenze operate con mezzi automatizzati
      per il miglioramento dell’offerta commerciale, oppure attraverso
      l’invio di sondaggi o questionari di rilevazione della
      soddisfazione dei clienti in relazione ai servizi di
      {{ settings.agency_name }};
    </mat-checkbox>
  </div>
  <div class="col-md-12 mb-3">
    <mat-checkbox formControlName="marketing_privacy">Alla comunicazione dei dati a società partner
      di {{ settings.agency_name }} per
      l'invio di comunicazioni commerciali e promozionali da parte di tali società terze;
    </mat-checkbox>
  </div>
  <div class="col-md-12 mt-5 d-flex justify-content-center">
    <button
      [disabled]="isLoading()"
      class=" btn btn-main-bg px-2 color-white py-5 btn-form"
      mat-button
      type="submit"
      >
      @if (isLoading()) {
        <span class="spinner-border spinner-border-sm mr-1"></span>
        } Registrati
      </button>
    </div>
  </div>
}
</form>
}



<ng-template #itemTemplate let-item>
  <a [innerHTML]="item?.name"></a>
</ng-template>

<ng-template #notFoundTemplate let-notFound>
  <div [innerHTML]="notFound"></div>
</ng-template>

</div>
</div>
</div>
